var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hydrated)?_c('InputGenerator',{key:_vm.namespace,attrs:{"name":_vm.fieldName,"inputData":_vm.dataArray,"namespace":_vm.namespace,"fieldsInGroup":parseInt(_vm.fieldOptions.fields_in_group),"groupInline":_vm.fieldOptions.groupInline,"groupNumbered":_vm.fieldOptions.groupNumbered,"groupFields":_vm.fieldOptions.group.fields}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }